export default __webpack_public_path__ + "static/media/info.52f4a2d8.svg";